import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import { GEOInputExportRequest, GEOInputUploadRequest } from '../requests/GEOInputFileRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GEOInputExport = (userId) => async (dispatch) => {
	await GEOInputExportRequest(userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GEOInputUpload = (file, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		GEOInputUploadRequest(response.data, userId).then(response2 => {
			console.log(response2.data);
			if (response2.data.includes('uploaded with success')) {
				dispatch(GEOInputExport(userId));
			} else {
				dispatch(enqueueSnackbar({ message: 'Upload fail', options: { variant: 'error' } }));
			}
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
